import { Component, ViewChild, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { MatDrawer } from '@angular/material';

import { GlobalCfgService } from '../../services/globalcfg.service';
import { UserService } from '../../services/user.service';
import { MiscService } from '../../services/misc.service';
import { EventBusService } from '../../services/event-bus.service';
import { SidenavbarViewService } from '../../services/sidenavbar-view.service';

@Component({
  selector: 'rm-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.css']
})
export class AdminLayoutComponent implements OnInit {

	role: any;
	view: any;
	labels: any;
	subcriptions: any[] = [];
	showParticipantSelection: boolean = true;
	@ViewChild('drawer', { static: false}) drawer: MatDrawer;
	showContent: boolean = false;
	
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private globalCfgService: GlobalCfgService,
		private userService: UserService,
		private miscService: MiscService,
		private ebService: EventBusService,
		public sidenavbarViewService: SidenavbarViewService
	) {}

	ngOnInit() {
		var user = this.globalCfgService.getLoggedInUser();
		this.ebService.hideGcpChangeValue$.subscribe(
			val=> {
				this.showParticipantSelection = val;
			}
		);

		this.route.url.subscribe(
			(url)=> {
				var v = url.values();
				//always the first part is role
				this.role = v.next().value.path;

				if (url.length > 1) {
					this.view = v.next().value.path;
				}
			});
			
		
		if (!user || Object.keys(user).length == 0) {
			this.router.navigateByUrl('/');
			this.showContent = false;
		} else {
			this.userService.getUserDetail(user['userId']).subscribe(
				(response: any) => {
					this.globalCfgService.setFullUserObj(response);

					if (response.role == 'admin') {
						window.localStorage.setItem('gcp', response.gcp);
						this.miscService.getLabels('admin').subscribe(
						(labels: any[])=> {
							this.labels = JSON.parse(labels[0].value);
							this.globalCfgService.setSettings({
								labels: this.labels
							});

							this.miscService.getACL('admin').subscribe(
								(acls: any[])=> {
									var acl = JSON.parse(acls[0].value);

									this.globalCfgService.setAcl(acl);
									this.ebService.onReadySource.next();
									this.showContent = true;
								}
							);

						});
					}
					
				});
		}

		this.subcriptions.push(this.ebService.toggleDrawerValue$.subscribe(
			drawer => {
				this.drawer.opened = drawer;
			}
		));


	}

	toggle() {
		// this.drawer.toggle();
		this.drawer.opened = !this.drawer.opened;
	}

	ngOnDestroy() {
		this.subcriptions.forEach(s => s.unsubscribe());
	}
}
